import type {BulkUpdateCreate} from '../types';
import {mapToBulkUpdateWorkField} from '../../services/bulkUpdates/mappers/mapBulkUpdateWorkField';
import type {Schemas} from '../dto.generated';
import {mapToBulkUpdateActionDto} from './mapBulkUpdateActionDto';

export const mapToBulkUpdateWorkRequest = (
  data: BulkUpdateCreate,
  ids: string[],
): Schemas.BulkUpdateWorkRequest => {
  return {
    field: mapToBulkUpdateWorkField(data),
    action: mapToBulkUpdateActionDto(data),
    ids: ids,
  };
};
